/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the ProjectElencoAssetInput interface.
 */
export function instanceOfProjectElencoAssetInput(value) {
    return true;
}
export function ProjectElencoAssetInputFromJSON(json) {
    return ProjectElencoAssetInputFromJSONTyped(json, false);
}
export function ProjectElencoAssetInputFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'] == null ? undefined : json['id'],
        'idProject': json['idProject'] == null ? undefined : json['idProject'],
        'idElencoAsset': json['idElencoAsset'] == null ? undefined : json['idElencoAsset'],
        'costo': json['costo'] == null ? undefined : json['costo'],
        'importo': json['importo'] == null ? undefined : json['importo'],
    };
}
export function ProjectElencoAssetInputToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'idProject': value['idProject'],
        'idElencoAsset': value['idElencoAsset'],
        'costo': value['costo'],
        'importo': value['importo'],
    };
}
